import {MarketElement, SelectionElement} from "../models/api/codegen/code";
import React, {useState} from "react";
import {MarketGroupItem} from "../components/CommonSportDisplay/desktop/Sport/MarketSelectionMenu";
import {useBreakpoints} from "../utils/useBreakpoints";
import { create } from 'zustand/react';

export type MarketGroup = MarketElement['g'];

export type TableCell = {
    selection: SelectionElement;
    value: string | number,
    isLabel: boolean;
    selectionId: number;
    selectionName: string;
    marketId: number;
    locked: boolean;
}

export type MarketTableRow = TableCell[];

export const PeriodMarketGroup = [
    {
        index: 0,
        name: 'MAIN',
        groups: ['DOUBLE_CHANCE', 'WINNER', 'TOTAL', 'HANDICAP', 'WINNER_HALF1', 'WINNER_HALF2', 'BOTH_WILL_SCORE']
    },
    {
        index: 1,
        name: 'HALF1',
        groups: ['WINNER_HALF1', 'DOUBLE_CHANCE_HALF1', 'TOTAL_HALF1', 'HANDICAP_HALF1', 'BOTH_WILL_SCORE_HALF1']
    },
    {
        index: 2,
        name: 'HALF2',
        groups: ['WINNER_HALF2', 'DOUBLE_CHANCE_HALF2', 'TOTAL_HALF2', 'HANDICAP_HALF2', 'BOTH_WILL_SCORE_HALF2']
    },
    {
        index: 1,
        name: 'HF1',
        groups: ['WINNER_HF1', 'DOUBLE_CHANCE_HF1', 'TOTAL_HF1', 'HANDICAP_HF1']
    },
    {
        index: 2,
        name: 'HF2',
        groups: ['WINNER_HF2', 'DOUBLE_CHANCE_HF2', 'TOTAL_HF2', 'HANDICAP_HF2']
    },
    {
        index: 1,
        name: 'QTR1',
        groups: ['WINNER_QTR1', 'DOUBLE_CHANCE_QTR1', 'TOTAL_QTR1', 'HANDICAP_QTR1']
    },
    {
        index: 2,
        name: 'QTR2',
        groups: ['WINNER_QTR2', 'DOUBLE_CHANCE_QTR2', 'TOTAL_QTR2', 'HANDICAP_QTR2']
    },
    {
        index: 3,
        name: 'QTR3',
        groups: ['WINNER_QTR3', 'DOUBLE_CHANCE_QTR3', 'TOTAL_QTR3', 'HANDICAP_QTR3']
    },
    {
        index: 4,
        name: 'QTR4',
        groups: ['WINNER_QTR4', 'DOUBLE_CHANCE_QTR4', 'TOTAL_QTR4', 'HANDICAP_QTR4']
    },
    {
        index: 1,
        name: 'SET1',
        groups: ['WINNER_SET1', 'DOUBLE_CHANCE_SET1', 'TOTAL_SET1', 'HANDICAP_SET1']
    },
    {
        index: 2,
        name: 'SET2',
        groups: ['WINNER_SET2', 'DOUBLE_CHANCE_SET2', 'TOTAL_SET2', 'HANDICAP_SET2']
    },
    {
        index: 3,
        name: 'SET3',
        groups: ['WINNER_SET3', 'DOUBLE_CHANCE_SET3', 'TOTAL_SET3', 'HANDICAP_SET3']
    },
    {
        index: 4,
        name: 'SET4',
        groups: ['WINNER_SET4', 'DOUBLE_CHANCE_SET4', 'TOTAL_SET4', 'HANDICAP_SET4']
    },
    {
        index: 5,
        name: 'SET5',
        groups: ['WINNER_SET5', 'DOUBLE_CHANCE_SET5', 'TOTAL_SET5', 'HANDICAP_SET5']
    },
    {
        index: 1,
        name: 'PERIOD1',
        groups: ['WINNER_PERIOD1', 'DOUBLE_CHANCE_PERIOD1', 'TOTAL_PERIOD1', 'HANDICAP_PERIOD1']
    },
    {
        index: 2,
        name: 'PERIOD2',
        groups: ['WINNER_PERIOD2', 'DOUBLE_CHANCE_PERIOD2', 'TOTAL_PERIOD2', 'HANDICAP_PERIOD2']
    },
    {
        index: 3,
        name: 'PERIOD3',
        groups: ['WINNER_PERIOD3', 'DOUBLE_CHANCE_PERIOD3', 'TOTAL_PERIOD3', 'HANDICAP_PERIOD3']
    },
    {
        index: 1,
        name: 'MAP1',
        groups: ['WINNER_MAP1', 'TOTAL_MAP1', 'HANDICAP_MAP1']
    },
    {
        index: 2,
        name: 'MAP2',
        groups: ['WINNER_MAP2', 'TOTAL_MAP2', 'HANDICAP_MAP2']
    },
    {
        index: 3,
        name: 'MAP3',
        groups: ['WINNER_MAP3', 'TOTAL_MAP3', 'HANDICAP_MAP3']
    },
    {
        index: 4,
        name: 'MAP4',
        groups: ['WINNER_MAP4', 'TOTAL_MAP4', 'HANDICAP_MAP4']
    },
    {
        index: 5,
        name: 'MAP5',
        groups: ['WINNER_MAP5', 'TOTAL_MAP5', 'HANDICAP_MAP5']
    },
    {
        index: 6,
        name: 'MAP6',
        groups: ['WINNER_MAP6', 'TOTAL_MAP6', 'HANDICAP_MAP6']
    },
    {
        index: 7,
        name: 'MAP7',
        groups: ['WINNER_MAP7', 'TOTAL_MAP7', 'HANDICAP_MAP7']
    },

];

export const MarketMenuGroup = [
    {
        name: 'WINNER' as MarketGroup,
        groups: ['WINNER', 'WINNER_HALF1', 'WINNER_HALF2', 'WINNER_SET1', 'WINNER_SET2', 'WINNER_SET3', 'WINNER_SET4', 'WINNER_SET5', 'WINNER_PERIOD1', 'WINNER_PERIOD2', 'WINNER_PERIOD3', 'WINNER_HF1', 'WINNER_HF2', 'WINNER_QTR1', 'WINNER_QTR2', 'WINNER_QTR3', 'WINNER_QTR4', 'WINNER_FULL_OT', 'WINNER_INNING1', 'WINNER_INNING2', 'WINNER_INNING3', 'WINNER_INNING4', 'WINNER_INNING5', 'WINNER_INNING6', 'WINNER_INNING7', 'WINNER_INNING8', 'WINNER_INNING9', 'WINNER_CRICKET_INNING1', 'WINNER_CRICKET_INNING2', 'WINNER_MAP1', 'WINNER_MAP2', 'WINNER_MAP3', 'WINNER_MAP4', 'WINNER_MAP5', 'WINNER_MAP6', 'WINNER_MAP7']
    },
    {
        name: 'DOUBLE_CHANCE' as MarketGroup,
        groups: ['DOUBLE_CHANCE', 'DOUBLE_CHANCE_HALF1', 'DOUBLE_CHANCE_HALF2', 'DOUBLE_CHANCE_HF1', 'DOUBLE_CHANCE_HF2', 'DOUBLE_CHANCE_QTR1', 'DOUBLE_CHANCE_QTR2', 'DOUBLE_CHANCE_QTR3', 'DOUBLE_CHANCE_QTR4', 'DOUBLE_CHANCE_PERIOD1', 'DOUBLE_CHANCE_PERIOD2', 'DOUBLE_CHANCE_PERIOD3']
    },
    {
        name: 'TOTAL' as MarketGroup,
        groups: ['TOTAL', 'TOTAL_HALF1', 'TOTAL_HALF2', 'TOTAL_SET1', 'TOTAL_SET2', 'TOTAL_SET3', 'TOTAL_SET4', 'TOTAL_SET5', 'TOTAL_PERIOD1', 'TOTAL_PERIOD2', 'TOTAL_PERIOD3', 'TOTAL_HF1', 'TOTAL_HF2', 'TOTAL_FULL_OT', 'TOTAL_FULL_OT_PS', 'TOTAL_QTR1', 'TOTAL_QTR2', 'TOTAL_QTR3', 'TOTAL_QTR4', 'TOTAL_INNING1', 'TOTAL_INNING2', 'TOTAL_INNING3', 'TOTAL_INNING4', 'TOTAL_INNING5', 'TOTAL_INNING6', 'TOTAL_INNING7', 'TOTAL_INNING8', 'TOTAL_INNING9', 'TOTAL_CRICKET_INNING1', 'TOTAL_CRICKET_INNING2', 'TOTAL_MAP1', 'TOTAL_MAP2', 'TOTAL_MAP3', 'TOTAL_MAP4', 'TOTAL_MAP5', 'TOTAL_MAP6', 'TOTAL_MAP7']
    },
    {
        name: "HANDICAP" as MarketGroup,
        groups: ['HANDICAP', 'HANDICAP_HALF1', 'HANDICAP_HALF2', 'HANDICAP_SETS', 'HANDICAP_SET1', 'HANDICAP_SET2', 'HANDICAP_SET3', 'HANDICAP_SET4', 'HANDICAP_SET5', 'HANDICAP_PERIODS', 'HANDICAP_PERIOD1', 'HANDICAP_HF1', 'HANDICAP_HF2', 'HANDICAP_FULL_OT', 'HANDICAP_FULL_OT_PS', 'HANDICAP_QTRS', 'HANDICAP_QTR1', 'HANDICAP_QTR2', 'HANDICAP_QTR3', 'HANDICAP_QTR4', 'HANDICAP_PERIOD2', 'HANDICAP_PERIOD3', 'HANDICAP_INNING1', 'HANDICAP_INNING2', 'HANDICAP_INNING3', 'HANDICAP_INNING4', 'HANDICAP_INNING5', 'HANDICAP_INNING6', 'HANDICAP_INNING7', 'HANDICAP_INNING8', 'HANDICAP_INNING9', 'HANDICAP_MAP1', 'HANDICAP_MAP2', 'HANDICAP_MAP3', 'HANDICAP_MAP4', 'HANDICAP_MAP5', 'HANDICAP_MAP6', 'HANDICAP_MAP7']
    },
    {
        name: "WINNER_HALF1" as MarketGroup,
        groups: ['WINNER_HALF1']
    },
    {
        name: "WINNER_HALF2" as MarketGroup,
        groups: ['WINNER_HALF2']
    },
    {
        name: "BOTH_WILL_SCORE" as MarketGroup,
        groups: ['BOTH_WILL_SCORE', 'BOTH_WILL_SCORE_HALF1', 'BOTH_WILL_SCORE_HALF2']
    }
];

export type MarketMenuType = 'DOUBLE_CHANCE' | 'WINNER' | 'TOTAL' | 'HANDICAP' | 'WINNER_HALF1' | 'WINNER_HALF2' | 'BOTH_WILL_SCORE';

interface MarketMenuState {
    itemsBySportId: Record<number, MarketGroupItem[]>;
    currentBySportId: Record<number, MarketGroup>;
    updateMarketGroupItems: (sportId: number, updater: ((prev: MarketGroupItem[]) => MarketGroupItem[]) | MarketGroupItem[]) => void;
    setCurrentMarketGroup: (sportId: number, group: MarketGroup) => void;
}

export const useMarketMenuStore = create<MarketMenuState>((set) => ({
    itemsBySportId: {},
    currentBySportId: {},
    updateMarketGroupItems: (sportId, updater) =>
        set((state) => ({
            itemsBySportId: {
                ...state.itemsBySportId,
                [sportId]: typeof updater === 'function' ? updater(state.itemsBySportId[sportId] || []) : updater,
            },
        })),
    setCurrentMarketGroup: (sportId, group) =>
        set((state) => ({
            currentBySportId: { ...state.currentBySportId, [sportId]: group },
        })),
}));

export function useMarketMenu(sportId: number) {
    const { isLessNoteBook, isMobile } = useBreakpoints();

    const marketGroupItems = useMarketMenuStore((state) => state.itemsBySportId[sportId] || []);
    const currentMarketGroup = useMarketMenuStore((state) => state.currentBySportId[sportId] ?? '');
    const updateMarketGroupItems = useMarketMenuStore((state) => state.updateMarketGroupItems);
    const setCurrentMarketGroup = useMarketMenuStore((state) => state.setCurrentMarketGroup);

    React.useEffect(() => {
        const initialItems = getInitialGroupItems(sportId, isLessNoteBook, isMobile);
        updateMarketGroupItems(sportId, initialItems);
        if (initialItems.length > 0) {
            setCurrentMarketGroup(sportId, initialItems[0].marketGroup);
        }
    }, [sportId, isLessNoteBook, isMobile, updateMarketGroupItems, setCurrentMarketGroup]);

    return { marketGroupItems, updateMarketGroupItems: (updater: any) => updateMarketGroupItems(sportId, updater), currentMarketGroup, setCurrentMarketGroup: (group: any) => setCurrentMarketGroup(sportId, group) };
}


interface MarketGroupsBySportType {
    [sportId: number]: Array<MarketGroup>
}

const marketGroupsBySport: MarketGroupsBySportType = {
    3: ['WINNER', 'HANDICAP', 'TOTAL', 'DOUBLE_CHANCE'],
    6: ['WINNER', 'HANDICAP', 'TOTAL'],
    9: ['WINNER', 'HANDICAP', 'TOTAL', 'DOUBLE_CHANCE'],
    12: ['WINNER', 'HANDICAP', 'TOTAL', 'DOUBLE_CHANCE'],
    15: ['WINNER', 'HANDICAP', 'TOTAL'],
    18: ['WINNER', 'TOTAL', 'DOUBLE_CHANCE'],
    21: ['DOUBLE_CHANCE', 'BOTH_WILL_SCORE'],
    24: ['WINNER', 'HANDICAP', 'TOTAL'],
    27: ['WINNER', 'HANDICAP', 'TOTAL'],
    30: ['WINNER', 'HANDICAP', 'TOTAL', 'DOUBLE_CHANCE'],
    37: ['WINNER', 'HANDICAP', 'TOTAL', 'DOUBLE_CHANCE'],
    40: ['WINNER', 'HANDICAP', 'TOTAL'],
    46: ['WINNER', 'HANDICAP', 'TOTAL', 'DOUBLE_CHANCE'],
    49: ['WINNER', 'HANDICAP', 'TOTAL', 'DOUBLE_CHANCE'],
    57: ['WINNER', 'HANDICAP', 'TOTAL', 'DOUBLE_CHANCE'],
    60: ['WINNER', 'HANDICAP', 'TOTAL', 'DOUBLE_CHANCE'],
    63: ['WINNER', 'HANDICAP', 'TOTAL'],
    67: ['WINNER', 'HANDICAP', 'TOTAL'],
    72: ['WINNER', 'HANDICAP', 'TOTAL', 'DOUBLE_CHANCE'],
    74: ['WINNER'],
    80: ['WINNER', 'HANDICAP', 'TOTAL', 'DOUBLE_CHANCE'],
    83: ['WINNER', 'TOTAL'],
    89: ['WINNER', 'HANDICAP', 'TOTAL'],
    93: ['WINNER'],
    95: ['WINNER'],
    98: ['WINNER', 'HANDICAP', 'TOTAL'],
    100: ['WINNER', 'TOTAL'],
    104: ['WINNER', 'HANDICAP', 'TOTAL', 'DOUBLE_CHANCE'],
    107: ['WINNER', 'HANDICAP', 'TOTAL', 'DOUBLE_CHANCE'],
    109: ['WINNER', 'HANDICAP', 'TOTAL', 'DOUBLE_CHANCE'],
    116: ['WINNER', 'HANDICAP', 'TOTAL'],
    123: ['WINNER', 'HANDICAP', 'TOTAL', 'DOUBLE_CHANCE'],
    129: ['WINNER', 'HANDICAP', 'TOTAL', 'DOUBLE_CHANCE'],
    134: ['WINNER', 'HANDICAP', 'TOTAL', 'DOUBLE_CHANCE'],
    136: ['WINNER_HALF1', 'WINNER_HALF2'],
    138: ['WINNER', 'HANDICAP', 'TOTAL', 'DOUBLE_CHANCE'],
    31102: ['WINNER', 'HANDICAP', 'TOTAL'],
    31110: ['WINNER', 'HANDICAP', 'TOTAL'],
    31112: ['WINNER', 'HANDICAP', 'TOTAL', 'DOUBLE_CHANCE'],
    31118: ['WINNER'],
    31122: ['WINNER', 'HANDICAP', 'TOTAL'],
}

export function getInitialGroupItems(sportId: number, isLessNoteBook: boolean, isMobile: boolean): MarketGroupItem[] {
    const markets = isLessNoteBook ? 2 : 3;
    return (marketGroupsBySport[sportId] || [{marketGroup: ''}])
        .map((el, i) => ({display: isMobile || i < markets, marketGroup: el as MarketMenuType}));
}

const selectionNames = {
    1: ['x', 'x'],
    2: ['yes', 'no'],
    3: ['1X', '12', 'X2'],
    4: ['x', 'x', 'x'],
    5: ['T', 'O', 'U'],
    6: ['IT1', 'O', 'U'],
    7: ['1', 'X', '2'],
    8: ['1', '2'],
    9: ['H1', 'K1', 'H2', 'K2']
};

export const marketToRows = {
    "NONE": selectionNames["1"],
    "AWAY_WILL_SCORE": selectionNames["2"],
    "HOME_WILL_SCORE": selectionNames["2"],
    "BOTH_WILL_SCORE": selectionNames["2"],
    "BOTH_WILL_SCORE_HALF1": selectionNames["2"],
    "BOTH_WILL_SCORE_HALF2": selectionNames["2"],
    "BOTH_WILL_SCORE_PERIOD1": selectionNames["2"],
    "BOTH_WILL_SCORE_PERIOD2": selectionNames["2"],
    "BOTH_WILL_SCORE_PERIOD3": selectionNames["2"],
    "DOUBLE_CHANCE": selectionNames["3"],
    "DOUBLE_CHANCE_HALF1": selectionNames["4"],
    "DOUBLE_CHANCE_HALF2": selectionNames["4"],
    "DOUBLE_CHANCE_HF1": selectionNames["4"],
    "DOUBLE_CHANCE_HF2": selectionNames["4"],
    "DOUBLE_CHANCE_QTR1": selectionNames["4"],
    "DOUBLE_CHANCE_QTR2": selectionNames["4"],
    "DOUBLE_CHANCE_QTR3": selectionNames["4"],
    "DOUBLE_CHANCE_QTR4": selectionNames["4"],
    "DOUBLE_CHANCE_PERIOD1": selectionNames["4"],
    "DOUBLE_CHANCE_PERIOD2": selectionNames["4"],
    "DOUBLE_CHANCE_PERIOD3": selectionNames["4"],
    "IND_TOTAL_HOME": selectionNames["5"],
    "IND_TOTAL_AWAY": selectionNames["5"],
    "IND_TOTAL_HOME_HALF1": selectionNames["6"],
    "IND_TOTAL_AWAY_HALF1": selectionNames["6"],
    "IND_TOTAL_HOME_HALF2": selectionNames["6"],
    "IND_TOTAL_AWAY_HALF2": selectionNames["6"],
    "IND_TOTAL_CARDS_HOME": selectionNames["6"],
    "IND_TOTAL_CARDS_AWAY": selectionNames["6"],
    "IND_TOTAL_CARDS_HOME_HALF1": selectionNames["6"],
    "IND_TOTAL_CARDS_AWAY_HALF1": selectionNames["6"],
    "IND_TOTAL_CORNERS_HOME": selectionNames["6"],
    "IND_TOTAL_CORNERS_AWAY": selectionNames["6"],
    "IND_TOTAL_CORNERS_HOME_HALF1": selectionNames["6"],
    "IND_TOTAL_CORNERS_AWAY_HALF1": selectionNames["6"],
    "IND_TOTAL_HOME_FULL": selectionNames["6"],
    "IND_TOTAL_AWAY_FULL": selectionNames["6"],
    "IND_TOTAL_HOME_FULL_EI": selectionNames["6"],
    "IND_TOTAL_AWAY_FULL_EI": selectionNames["6"],
    "IND_TOTAL_HOME_INNING1": selectionNames["6"],
    "IND_TOTAL_HOME_INNING2": selectionNames["6"],
    "IND_TOTAL_HOME_INNING3": selectionNames["6"],
    "IND_TOTAL_HOME_INNING4": selectionNames["6"],
    "IND_TOTAL_HOME_INNING5": selectionNames["6"],
    "IND_TOTAL_HOME_INNING6": selectionNames["6"],
    "IND_TOTAL_HOME_INNING7": selectionNames["6"],
    "IND_TOTAL_HOME_INNING8": selectionNames["6"],
    "IND_TOTAL_HOME_INNING9": selectionNames["6"],
    "IND_TOTAL_AWAY_INNING1": selectionNames["6"],
    "IND_TOTAL_AWAY_INNING2": selectionNames["6"],
    "IND_TOTAL_AWAY_INNING3": selectionNames["6"],
    "IND_TOTAL_AWAY_INNING4": selectionNames["6"],
    "IND_TOTAL_AWAY_INNING5": selectionNames["6"],
    "IND_TOTAL_AWAY_INNING6": selectionNames["6"],
    "IND_TOTAL_AWAY_INNING7": selectionNames["6"],
    "IND_TOTAL_AWAY_INNING8": selectionNames["6"],
    "IND_TOTAL_AWAY_INNING9": selectionNames["6"],
    "IND_TOTAL_HOME_CRICKET_INNING1": selectionNames["6"],
    "IND_TOTAL_HOME_CRICKET_INNING2": selectionNames["6"],
    "IND_TOTAL_AWAY_CRICKET_INNING1": selectionNames["6"],
    "IND_TOTAL_AWAY_CRICKET_INNING2": selectionNames["6"],
    "IND_TOTAL_HOME_SET1": selectionNames["6"],
    "IND_TOTAL_AWAY_SET1": selectionNames["6"],
    "IND_TOTAL_HOME_SET2": selectionNames["6"],
    "IND_TOTAL_AWAY_SET2": selectionNames["6"],
    "IND_TOTAL_HOME_SET3": selectionNames["6"],
    "IND_TOTAL_AWAY_SET3": selectionNames["6"],
    "IND_TOTAL_HOME_FULL_OT_PS": selectionNames["6"],
    "IND_TOTAL_AWAY_FULL_OT_PS": selectionNames["6"],
    "IND_TOTAL_HOME_PERIOD1": selectionNames["6"],
    "IND_TOTAL_HOME_PERIOD2": selectionNames["6"],
    "IND_TOTAL_HOME_PERIOD3": selectionNames["6"],
    "IND_TOTAL_AWAY_PERIOD1": selectionNames["6"],
    "IND_TOTAL_AWAY_PERIOD2": selectionNames["6"],
    "IND_TOTAL_AWAY_PERIOD3": selectionNames["6"],
    "IND_TOTAL_AWAY_MAP1": selectionNames["6"],
    "IND_TOTAL_AWAY_MAP2": selectionNames["6"],
    "IND_TOTAL_AWAY_MAP3": selectionNames["6"],
    "IND_TOTAL_AWAY_MAP4": selectionNames["6"],
    "IND_TOTAL_AWAY_MAP5": selectionNames["6"],
    "IND_TOTAL_AWAY_MAP6": selectionNames["6"],
    "IND_TOTAL_AWAY_MAP7": selectionNames["6"],
    "IND_TOTAL_HOME_MAP1": selectionNames["6"],
    "IND_TOTAL_HOME_MAP2": selectionNames["6"],
    "IND_TOTAL_HOME_MAP3": selectionNames["6"],
    "IND_TOTAL_HOME_MAP4": selectionNames["6"],
    "IND_TOTAL_HOME_MAP5": selectionNames["6"],
    "IND_TOTAL_HOME_MAP6": selectionNames["6"],
    "IND_TOTAL_HOME_MAP7": selectionNames["6"],
    "IND_TOTAL_HOME_HF1": selectionNames["6"],
    "IND_TOTAL_AWAY_HF1": selectionNames["6"],
    "IND_TOTAL_HOME_HF2": selectionNames["6"],
    "IND_TOTAL_AWAY_HF2": selectionNames["6"],
    "IND_TOTAL_HOME_FULL_OT": selectionNames["6"],
    "IND_TOTAL_AWAY_FULL_OT": selectionNames["6"],
    "IND_TOTAL_HOME_QTR1": selectionNames["6"],
    "IND_TOTAL_AWAY_QTR1": selectionNames["6"],
    "IND_TOTAL_HOME_QTR2": selectionNames["6"],
    "IND_TOTAL_AWAY_QTR2": selectionNames["6"],
    "IND_TOTAL_HOME_QTR3": selectionNames["6"],
    "IND_TOTAL_AWAY_QTR3": selectionNames["6"],
    "IND_TOTAL_HOME_QTR4": selectionNames["6"],
    "IND_TOTAL_AWAY_QTR4": selectionNames["6"],
    "WINNER": selectionNames["7"],
    "WINNER_FULL_EI": selectionNames["7"],
    "WINNER_INNING1": selectionNames["7"],
    "WINNER_INNING2": selectionNames["7"],
    "WINNER_INNING3": selectionNames["7"],
    "WINNER_INNING4": selectionNames["7"],
    "WINNER_INNING5": selectionNames["7"],
    "WINNER_INNING6": selectionNames["7"],
    "WINNER_INNING7": selectionNames["7"],
    "WINNER_INNING8": selectionNames["7"],
    "WINNER_INNING9": selectionNames["7"],
    "WINNER_CRICKET_INNING1": selectionNames["7"],
    "WINNER_CRICKET_INNING2": selectionNames["7"],
    "WINNER_HALF1": selectionNames["7"],
    "WINNER_HALF2": selectionNames["7"],
    "WINNER_CARDS": selectionNames["7"],
    "WINNER_CARDS_HALF1": selectionNames["7"],
    "WINNER_CARDS_HALF2": selectionNames["7"],
    "WINNER_CORNERS": selectionNames["7"],
    "WINNER_CORNERS_HALF1": selectionNames["7"],
    "WINNER_CORNERS_HALF2": selectionNames["7"],
    "WINNER_SET1": selectionNames["7"],
    "WINNER_SET2": selectionNames["7"],
    "WINNER_SET3": selectionNames["7"],
    "WINNER_SET4": selectionNames["7"],
    "WINNER_SET5": selectionNames["7"],
    "WINNER_PERIOD1": selectionNames["7"],
    "WINNER_PERIOD2": selectionNames["7"],
    "WINNER_PERIOD3": selectionNames["7"],
    "WINNER_MAP1": selectionNames["7"],
    "WINNER_MAP2": selectionNames["7"],
    "WINNER_MAP3": selectionNames["7"],
    "WINNER_MAP4": selectionNames["7"],
    "WINNER_MAP5": selectionNames["7"],
    "WINNER_MAP6": selectionNames["7"],
    "WINNER_MAP7": selectionNames["7"],
    "WINNER_HF1": selectionNames["7"],
    "WINNER_HF2": selectionNames["7"],
    "WINNER_QTR1": selectionNames["7"],
    "WINNER_QTR2": selectionNames["7"],
    "WINNER_QTR3": selectionNames["7"],
    "WINNER_QTR4": selectionNames["7"],
    "WINNER_FULL_OT": selectionNames["7"],
    "WINNER_FULL_OT_PS": selectionNames["8"],
    "TOTAL": selectionNames["5"],
    "TOTAL_FULL_EI": selectionNames["6"],
    "TOTAL_INNING1": selectionNames["6"],
    "TOTAL_INNING2": selectionNames["6"],
    "TOTAL_INNING3": selectionNames["6"],
    "TOTAL_INNING4": selectionNames["6"],
    "TOTAL_INNING5": selectionNames["6"],
    "TOTAL_INNING6": selectionNames["6"],
    "TOTAL_INNING7": selectionNames["6"],
    "TOTAL_INNING8": selectionNames["6"],
    "TOTAL_INNING9": selectionNames["6"],
    "TOTAL_CRICKET_INNING1": selectionNames["6"],
    "TOTAL_CRICKET_INNING2": selectionNames["6"],
    "TOTAL_HALF1": selectionNames["6"],
    "TOTAL_HALF2": selectionNames["6"],
    "TOTAL_CARDS": selectionNames["6"],
    "TOTAL_CARDS_HALF1": selectionNames["6"],
    "TOTAL_CARDS_HALF2": selectionNames["6"],
    "TOTAL_CORNERS": selectionNames["6"],
    "TOTAL_CORNERS_HALF1": selectionNames["6"],
    "TOTAL_CORNERS_HALF2": selectionNames["6"],
    "TOTAL_SET1": selectionNames["6"],
    "TOTAL_SET2": selectionNames["6"],
    "TOTAL_SET3": selectionNames["6"],
    "TOTAL_SET4": selectionNames["6"],
    "TOTAL_SET5": selectionNames["6"],
    "TOTAL_PERIOD1": selectionNames["6"],
    "TOTAL_PERIOD2": selectionNames["6"],
    "TOTAL_PERIOD3": selectionNames["6"],
    "TOTAL_HF1": selectionNames["6"],
    "TOTAL_HF2": selectionNames["6"],
    "TOTAL_FULL_OT": selectionNames["6"],
    "TOTAL_FULL_OT_PS": selectionNames["6"],
    "TOTAL_QTR1": selectionNames["6"],
    "TOTAL_QTR2": selectionNames["6"],
    "TOTAL_QTR3": selectionNames["6"],
    "TOTAL_QTR4": selectionNames["6"],
    "TOTAL_FRAMES": selectionNames["6"],
    "TOTAL_MAP1": selectionNames["6"],
    "TOTAL_MAP2": selectionNames["6"],
    "TOTAL_MAP3": selectionNames["6"],
    "TOTAL_MAP4": selectionNames["6"],
    "TOTAL_MAP5": selectionNames["6"],
    "TOTAL_MAP6": selectionNames["6"],
    "TOTAL_MAP7": selectionNames["6"],
    "HANDICAP": selectionNames["9"],
    "HANDICAP_HALF1": selectionNames["9"],
    "HANDICAP_HALF2": selectionNames["9"],
    "HANDICAP_CORNERS": selectionNames["9"],
    "HANDICAP_CORNERS_HALF1": selectionNames["9"],
    "HANDICAP_CORNERS_HALF2": selectionNames["9"],
    "HANDICAP_SET1": selectionNames["9"],
    "HANDICAP_SET2": selectionNames["9"],
    "HANDICAP_SET3": selectionNames["9"],
    "HANDICAP_SET4": selectionNames["9"],
    "HANDICAP_SET5": selectionNames["9"],
    "HANDICAP_PERIOD1": selectionNames["9"],
    "HANDICAP_PERIOD2": selectionNames["9"],
    "HANDICAP_PERIOD3": selectionNames["9"],
    "HANDICAP_MAP1": selectionNames["9"],
    "HANDICAP_MAP2": selectionNames["9"],
    "HANDICAP_MAP3": selectionNames["9"],
    "HANDICAP_MAP4": selectionNames["9"],
    "HANDICAP_MAP5": selectionNames["9"],
    "HANDICAP_MAP6": selectionNames["9"],
    "HANDICAP_MAP7": selectionNames["9"],
    "HANDICAP_HF1": selectionNames["9"],
    "HANDICAP_HF2": selectionNames["9"],
    "HANDICAP_FULL_OT": selectionNames["9"],
    "HANDICAP_FULL_OT_PS": selectionNames["9"],
    "HANDICAP_QTR1": selectionNames["9"],
    "HANDICAP_QTR2": selectionNames["9"],
    "HANDICAP_QTR3": selectionNames["9"],
    "HANDICAP_QTR4": selectionNames["9"],
    "HANDICAP_FULL_EI": selectionNames["9"],
    "HANDICAP_INNING1": selectionNames["9"],
    "HANDICAP_INNING2": selectionNames["9"],
    "HANDICAP_INNING3": selectionNames["9"],
    "HANDICAP_INNING4": selectionNames["9"],
    "HANDICAP_INNING5": selectionNames["9"],
    "HANDICAP_INNING6": selectionNames["9"],
    "HANDICAP_INNING7": selectionNames["9"],
    "HANDICAP_INNING8": selectionNames["9"],
    "HANDICAP_INNING9": selectionNames["9"],
    "HANDICAP_FRAMES": selectionNames["9"],


    "WINNER_SET6": selectionNames["7"],
    "WINNER_SET7": selectionNames["7"],

    "TOTAL_SET6": selectionNames["6"],
    "TOTAL_SET7": selectionNames["6"],

    "HANDICAP_SET6": selectionNames["9"],
    "HANDICAP_SET7": selectionNames["9"],
    "EXACT_QUANTITY": selectionNames["1"],
    "CORRECT_SCORE": selectionNames["1"]

};


export const marketGroupFunctions = {
    "NONE": generateWinner,
    "UNKNOWN": generateWinner,
    "AWAY_WILL_SCORE": generateHalfOutcome,
    "HOME_WILL_SCORE": generateHalfOutcome,
    "BOTH_WILL_SCORE": generateHalfOutcome,
    "BOTH_WILL_SCORE_HALF1": generateHalfOutcome,
    "BOTH_WILL_SCORE_HALF2": generateHalfOutcome,
    "BOTH_WILL_SCORE_PERIOD1": generateHalfOutcome,
    "BOTH_WILL_SCORE_PERIOD2": generateHalfOutcome,
    "BOTH_WILL_SCORE_PERIOD3": generateHalfOutcome,
    "DOUBLE_CHANCE": generateWinner,
    "DOUBLE_CHANCE_HALF1": generateWinner,
    "DOUBLE_CHANCE_HALF2": generateWinner,
    "DOUBLE_CHANCE_HF1": generateWinner,
    "DOUBLE_CHANCE_HF2": generateWinner,
    "DOUBLE_CHANCE_QTR1": generateWinner,
    "DOUBLE_CHANCE_QTR2": generateWinner,
    "DOUBLE_CHANCE_QTR3": generateWinner,
    "DOUBLE_CHANCE_QTR4": generateWinner,
    "DOUBLE_CHANCE_PERIOD1": generateWinner,
    "DOUBLE_CHANCE_PERIOD2": generateWinner,
    "DOUBLE_CHANCE_PERIOD3": generateWinner,
    "IND_TOTAL_HOME_FULL": generateTotal,
    "IND_TOTAL_AWAY_FULL": generateTotal,
    "IND_TOTAL_HOME_FULL_EI": generateTotal,
    "IND_TOTAL_AWAY_FULL_EI": generateTotal,
    "IND_TOTAL_HOME_INNING1": generateTotal,
    "IND_TOTAL_HOME_INNING2": generateTotal,
    "IND_TOTAL_HOME_INNING3": generateTotal,
    "IND_TOTAL_HOME_INNING4": generateTotal,
    "IND_TOTAL_HOME_INNING5": generateTotal,
    "IND_TOTAL_HOME_INNING6": generateTotal,
    "IND_TOTAL_HOME_INNING7": generateTotal,
    "IND_TOTAL_HOME_INNING8": generateTotal,
    "IND_TOTAL_HOME_INNING9": generateTotal,
    "IND_TOTAL_AWAY_INNING1": generateTotal,
    "IND_TOTAL_AWAY_INNING2": generateTotal,
    "IND_TOTAL_AWAY_INNING3": generateTotal,
    "IND_TOTAL_AWAY_INNING4": generateTotal,
    "IND_TOTAL_AWAY_INNING5": generateTotal,
    "IND_TOTAL_AWAY_INNING6": generateTotal,
    "IND_TOTAL_AWAY_INNING7": generateTotal,
    "IND_TOTAL_AWAY_INNING8": generateTotal,
    "IND_TOTAL_AWAY_INNING9": generateTotal,
    "IND_TOTAL_HOME_CRICKET_INNING1": generateTotal,
    "IND_TOTAL_HOME_CRICKET_INNING2": generateTotal,
    "IND_TOTAL_AWAY_CRICKET_INNING1": generateTotal,
    "IND_TOTAL_AWAY_CRICKET_INNING2": generateTotal,
    "IND_TOTAL_HOME_SET1": generateTotal,
    "IND_TOTAL_AWAY_SET1": generateTotal,
    "IND_TOTAL_HOME_SET2": generateTotal,
    "IND_TOTAL_AWAY_SET2": generateTotal,
    "IND_TOTAL_HOME_SET3": generateTotal,
    "IND_TOTAL_AWAY_SET3": generateTotal,
    "IND_TOTAL_HOME": generateTotal,
    "IND_TOTAL_AWAY": generateTotal,
    "IND_TOTAL_HOME_HALF1": generateTotal,
    "IND_TOTAL_AWAY_HALF1": generateTotal,
    "IND_TOTAL_HOME_HALF2": generateTotal,
    "IND_TOTAL_AWAY_HALF2": generateTotal,
    "IND_TOTAL_CARDS_HOME": generateTotal,
    "IND_TOTAL_CARDS_AWAY": generateTotal,
    "IND_TOTAL_CARDS_HOME_HALF1": generateTotal,
    "IND_TOTAL_CARDS_AWAY_HALF1": generateTotal,
    "IND_TOTAL_CORNERS_HOME": generateTotal,
    "IND_TOTAL_CORNERS_AWAY": generateTotal,
    "IND_TOTAL_CORNERS_HOME_HALF1": generateTotal,
    "IND_TOTAL_CORNERS_AWAY_HALF1": generateTotal,
    "IND_TOTAL_HOME_FULL_OT_PS": generateTotal,
    "IND_TOTAL_AWAY_FULL_OT_PS": generateTotal,
    "IND_TOTAL_HOME_PERIOD1": generateTotal,
    "IND_TOTAL_HOME_PERIOD2": generateTotal,
    "IND_TOTAL_HOME_PERIOD3": generateTotal,
    "IND_TOTAL_AWAY_PERIOD1": generateTotal,
    "IND_TOTAL_AWAY_PERIOD2": generateTotal,
    "IND_TOTAL_AWAY_PERIOD3": generateTotal,
    "IND_TOTAL_AWAY_MAP1": generateTotal,
    "IND_TOTAL_AWAY_MAP2": generateTotal,
    "IND_TOTAL_AWAY_MAP3": generateTotal,
    "IND_TOTAL_AWAY_MAP4": generateTotal,
    "IND_TOTAL_AWAY_MAP5": generateTotal,
    "IND_TOTAL_AWAY_MAP6": generateTotal,
    "IND_TOTAL_AWAY_MAP7": generateTotal,
    "IND_TOTAL_HOME_MAP1": generateTotal,
    "IND_TOTAL_HOME_MAP2": generateTotal,
    "IND_TOTAL_HOME_MAP3": generateTotal,
    "IND_TOTAL_HOME_MAP4": generateTotal,
    "IND_TOTAL_HOME_MAP5": generateTotal,
    "IND_TOTAL_HOME_MAP6": generateTotal,
    "IND_TOTAL_HOME_MAP7": generateTotal,
    "IND_TOTAL_HOME_HF1": generateTotal,
    "IND_TOTAL_AWAY_HF1": generateTotal,
    "IND_TOTAL_HOME_HF2": generateTotal,
    "IND_TOTAL_AWAY_HF2": generateTotal,
    "IND_TOTAL_HOME_FULL_OT": generateTotal,
    "IND_TOTAL_AWAY_FULL_OT": generateTotal,
    "IND_TOTAL_HOME_QTR1": generateTotal,
    "IND_TOTAL_AWAY_QTR1": generateTotal,
    "IND_TOTAL_HOME_QTR2": generateTotal,
    "IND_TOTAL_AWAY_QTR2": generateTotal,
    "IND_TOTAL_HOME_QTR3": generateTotal,
    "IND_TOTAL_AWAY_QTR3": generateTotal,
    "IND_TOTAL_HOME_QTR4": generateTotal,
    "IND_TOTAL_AWAY_QTR4": generateTotal,
    "WINNER": generateWinner,
    "WINNER_FULL_EI": generateWinner,
    "WINNER_INNING1": generateWinner,
    "WINNER_INNING2": generateWinner,
    "WINNER_INNING3": generateWinner,
    "WINNER_INNING4": generateWinner,
    "WINNER_INNING5": generateWinner,
    "WINNER_INNING6": generateWinner,
    "WINNER_INNING7": generateWinner,
    "WINNER_INNING8": generateWinner,
    "WINNER_INNING9": generateWinner,
    "WINNER_CRICKET_INNING1": generateWinner,
    "WINNER_CRICKET_INNING2": generateWinner,
    "WINNER_HALF1": generateWinner,
    "WINNER_HALF2": generateWinner,
    "WINNER_CARDS": generateWinner,
    "WINNER_CARDS_HALF1": generateWinner,
    "WINNER_CARDS_HALF2": generateWinner,
    "WINNER_CORNERS": generateWinner,
    "WINNER_CORNERS_HALF1": generateWinner,
    "WINNER_CORNERS_HALF2": generateWinner,
    "WINNER_SET1": generateWinner,
    "WINNER_SET2": generateWinner,
    "WINNER_SET3": generateWinner,
    "WINNER_SET4": generateWinner,
    "WINNER_SET5": generateWinner,
    "WINNER_PERIOD1": generateWinner,
    "WINNER_PERIOD2": generateWinner,
    "WINNER_PERIOD3": generateWinner,
    "WINNER_HF1": generateWinner,
    "WINNER_HF2": generateWinner,
    "WINNER_QTR1": generateWinner,
    "WINNER_QTR2": generateWinner,
    "WINNER_QTR3": generateWinner,
    "WINNER_QTR4": generateWinner,
    "WINNER_FULL_OT": generateWinner,
    "WINNER_FULL_OT_PS": generateWinner,
    "WINNER_MAP1": generateWinner,
    "WINNER_MAP2": generateWinner,
    "WINNER_MAP3": generateWinner,
    "WINNER_MAP4": generateWinner,
    "WINNER_MAP5": generateWinner,
    "WINNER_MAP6": generateWinner,
    "WINNER_MAP7": generateWinner,
    "TOTAL": generateTotal,
    "TOTAL_FULL_EI": generateTotal,
    "TOTAL_INNING1": generateTotal,
    "TOTAL_INNING2": generateTotal,
    "TOTAL_INNING3": generateTotal,
    "TOTAL_INNING4": generateTotal,
    "TOTAL_INNING5": generateTotal,
    "TOTAL_INNING6": generateTotal,
    "TOTAL_INNING7": generateTotal,
    "TOTAL_INNING8": generateTotal,
    "TOTAL_INNING9": generateTotal,
    "TOTAL_CRICKET_INNING1": generateTotal,
    "TOTAL_CRICKET_INNING2": generateTotal,
    "TOTAL_HALF1": generateTotal,
    "TOTAL_HALF2": generateTotal,
    "TOTAL_CARDS": generateTotal,
    "TOTAL_CARDS_HALF1": generateTotal,
    "TOTAL_CARDS_HALF2": generateTotal,
    "TOTAL_CORNERS": generateTotal,
    "TOTAL_CORNERS_HALF1": generateTotal,
    "TOTAL_CORNERS_HALF2": generateTotal,
    "TOTAL_MAP1": generateTotal,
    "TOTAL_MAP2": generateTotal,
    "TOTAL_MAP3": generateTotal,
    "TOTAL_MAP4": generateTotal,
    "TOTAL_MAP5": generateTotal,
    "TOTAL_MAP6": generateTotal,
    "TOTAL_MAP7": generateTotal,
    "TOTAL_SET1": generateTotal,
    "TOTAL_SET2": generateTotal,
    "TOTAL_SET3": generateTotal,
    "TOTAL_SET4": generateTotal,
    "TOTAL_SET5": generateTotal,
    "TOTAL_PERIOD1": generateTotal,
    "TOTAL_PERIOD2": generateTotal,
    "TOTAL_PERIOD3": generateTotal,
    "TOTAL_HF1": generateTotal,
    "TOTAL_HF2": generateTotal,
    "TOTAL_FULL_OT": generateTotal,
    "TOTAL_FULL_OT_PS": generateTotal,
    "TOTAL_QTRS": generateTotal,
    "TOTAL_QTR1": generateTotal,
    "TOTAL_QTR2": generateTotal,
    "TOTAL_QTR3": generateTotal,
    "TOTAL_QTR4": generateTotal,
    "TOTAL_FRAMES": generateTotal,
    "HANDICAP": generateHandicap,
    "HANDICAP_HALF1": generateHandicap,
    "HANDICAP_HALF2": generateHandicap,
    "HANDICAP_CORNERS": generateHandicap,
    "HANDICAP_CORNERS_HALF1": generateHandicap,
    "HANDICAP_CORNERS_HALF2": generateHandicap,
    "HANDICAP_SET1": generateHandicap,
    "HANDICAP_SET2": generateHandicap,
    "HANDICAP_SET3": generateHandicap,
    "HANDICAP_SET4": generateHandicap,
    "HANDICAP_SET5": generateHandicap,
    "HANDICAP_PERIOD1": generateHandicap,
    "HANDICAP_PERIOD2": generateHandicap,
    "HANDICAP_PERIOD3": generateHandicap,
    "HANDICAP_MAP1": generateHandicap,
    "HANDICAP_MAP2": generateHandicap,
    "HANDICAP_MAP3": generateHandicap,
    "HANDICAP_MAP4": generateHandicap,
    "HANDICAP_MAP5": generateHandicap,
    "HANDICAP_MAP6": generateHandicap,
    "HANDICAP_MAP7": generateHandicap,
    "HANDICAP_HF1": generateHandicap,
    "HANDICAP_HF2": generateHandicap,
    "HANDICAP_FULL_OT": generateHandicap,
    "HANDICAP_FULL_OT_PS": generateHandicap,
    "HANDICAP_QTR1": generateHandicap,
    "HANDICAP_QTR2": generateHandicap,
    "HANDICAP_QTR3": generateHandicap,
    "HANDICAP_QTR4": generateHandicap,
    "HANDICAP_FULL_EI": generateHandicap,
    "HANDICAP_INNING1": generateHandicap,
    "HANDICAP_INNING2": generateHandicap,
    "HANDICAP_INNING3": generateHandicap,
    "HANDICAP_INNING4": generateHandicap,
    "HANDICAP_INNING5": generateHandicap,
    "HANDICAP_INNING6": generateHandicap,
    "HANDICAP_INNING7": generateHandicap,
    "HANDICAP_INNING8": generateHandicap,
    "HANDICAP_INNING9": generateHandicap,
    "HANDICAP_FRAMES": generateHandicap,

    "WINNER_SET6": generateWinner,
    "WINNER_SET7": generateWinner,

    "TOTAL_SET6": generateTotal,
    "TOTAL_SET7": generateTotal,

    "HANDICAP_SET6": generateHandicap,
    "HANDICAP_SET7": generateHandicap,

    "EXACT_QUANTITY": generateHandicap,
    "CORRECT_SCORE": generateHandicap
};

export function marketColTitlesByMarketGroup(ma: MarketElement['g']) {
    // const s = 'winner';
    return marketToRows[ma];
}


function generateWinner(selections: SelectionElement[], marketId: number): MarketTableRow {
    // marketToRows['WINNER'].map(l => ({
    //     value: l.
    // }));
    if (selections.length === 2) {
        const empty = {
            selection: {} as SelectionElement,
            value: 0,
            isLabel: false,
            selectionId: 0,
            selectionName: "",
            marketId: marketId,
            locked: true
        };
        return [map(selections[0], marketId), empty, map(selections[1], marketId)]
    }
    return selections.map(sel => map(sel, marketId));
}

function generateHalfOutcome(selections: SelectionElement[], marketId: number): MarketTableRow {
    return selections.map(sel => map(sel, marketId));
}

const map = (sel: SelectionElement, marketId: number) => ({
    selection: sel,
    value: sel.o,
    isLabel: false,
    selectionId: sel.i,
    selectionName: sel.n,
    marketId: marketId,
    locked: sel.lc
});

function generateTotal(selections: SelectionElement[], marketId: number): MarketTableRow {
    if (!selections || selections.length === 0) return [] as TableCell[];
    const value = selections[0].bl;
    return selections.filter(selection => selection.bl === value).reduce((acc: TableCell[], curr: SelectionElement) => {
        return acc.concat({
            selection: curr,
            value: curr.o,
            isLabel: false,
            selectionId: curr.i,
            selectionName: curr.n,
            marketId: marketId,
            locked: curr.lc
        });
    }, [{
        selection: selections[0],
        value: value,
        isLabel: true
    } as TableCell] as TableCell[]);
}

function generateHandicap(selections: SelectionElement[], marketId: number): MarketTableRow {
    const value = selections[0].bl;
    return selections.filter(selection => selection.bl === value).reduce((acc: TableCell[], curr: SelectionElement) => {
        return acc.concat([
            {

                selection: curr,
                value: curr.v !== undefined ? `${curr.v}` : curr.n,
                isLabel: true,
                selectionId: -1,
                selectionName: curr.n,
                marketId: marketId,
                locked: false
            },
            {
                selection: curr,
                value: curr.o,
                isLabel: false,
                selectionId: curr.i,
                selectionName: curr.n,
                marketId: marketId,
                locked: curr.lc
            }
        ]);
    }, [] as TableCell[]);
}
